(function () {
  'use strict';

  function initAjaxCart() {
    document.addEventListener('submit', async function (event) {
      const form = event.target;

      if (!form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();

      const button = form.querySelector('button[name="add"]');
      if (!button || button.disabled) return;

      const originalHTML = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding...';

      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin'
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || 'Unable to add product.');
        }

        button.textContent = 'Added to cart!';

        // Refresh cart count
        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();

        document.querySelectorAll('#CartCount').forEach(function (el) {
        // Preserve Debut's existing badge markup
        const countElement = el.querySelector('span');

        if (countElement) {
            countElement.textContent = cart.item_count;
        } else {
            el.textContent = cart.item_count;
        }

        if (cart.item_count > 0) {
            el.classList.remove('hide', 'hidden-count');
        } else {
            el.classList.add('hide');
        }
        });

        // Display confirmation
        let feedback = form.querySelector('.custom-cart-feedback');

        if (!feedback) {
          feedback = document.createElement('div');
          feedback.className = 'custom-cart-feedback';
          feedback.setAttribute('role', 'status');
          form.appendChild(feedback);
        }

        feedback.innerHTML =
          '✓ Added to cart! <a href="' + root +
          'cart">View cart</a> or continue shopping.';

      } catch (error) {
        alert(error.message);
      } finally {
        setTimeout(function () {
          button.disabled = false;
          button.innerHTML = originalHTML;
        }, 1500);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxCart);
  } else {
    initAjaxCart();
  }
})();